// FUNCTIONALITY-111/115A/115C-R1 — contact manager helpers (external-link adapter).
import { STORE_INFO } from "./store-info-v2.js";
import { STAGING_STORE_TELEGRAM_URL } from "./external-link-v2.js";

export type ContactOpenResult = { kind: "opened" } | { kind: "modal" } | { kind: "logged_only" };

/** Exact approved public t.me URL (settings/env first; staging store bot as last resort). */
export function resolveManagerPublicUrl(): string | null {
  try {
    const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};
    const configured = (env.VITE_MANAGER_CONTACT_URL || env.VITE_SUPPORT_TELEGRAM_URL || "").trim();
    if (configured && /^https:\/\/t\.me\//i.test(configured)) return configured;
  } catch {
    /* Node guard / non-Vite runtime */
  }
  if (STORE_INFO.managerTelegram && /^https:\/\/t\.me\//i.test(STORE_INFO.managerTelegram)) {
    return STORE_INFO.managerTelegram;
  }
  return STAGING_STORE_TELEGRAM_URL;
}

/**
 * FUNCTIONALITY-115C-R1 — always open the Contact Manager modal.
 * Phone / Viber / Telegram run only after an explicit button click inside the modal.
 */
export async function openManagerContact(): Promise<ContactOpenResult> {
  return { kind: "modal" };
}

export async function copyText(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = value;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
